import {useEffect,useRef} from 'react';

/** Keep keyboard focus and scrolling inside a custom dialog. */
export function useOverlay<T extends HTMLElement>(onClose:()=>void,busy=false) {
  const root=useRef<T>(null);
  const current=useRef({onClose,busy});current.current={onClose,busy};
  useEffect(()=>{
    const previous=document.activeElement as HTMLElement|null;
    const overflow=document.body.style.overflow;document.body.style.overflow='hidden';
    const controls=()=>Array.from(root.current?.querySelectorAll<HTMLElement>('button,input,select,textarea,a[href],[tabindex="0"]')||[]).filter(e=>!e.hasAttribute('disabled') && !e.closest('[inert]') && e.getClientRects().length>0);
    (root.current?.querySelector<HTMLElement>('[autofocus]') || controls()[0])?.focus({preventScroll:true});
    const key=(event:KeyboardEvent)=>{
      if(document.querySelector('dialog[open]'))return;
      if(event.key==='Escape'){event.preventDefault();if(!current.current.busy)current.current.onClose();}
      if(event.key==='Tab'){
        const items=controls();const first=items[0],last=items[items.length-1];
        if(!first){event.preventDefault();return;}
        if(event.shiftKey && (document.activeElement===first || !root.current?.contains(document.activeElement))){event.preventDefault();last.focus();}
        else if(!event.shiftKey && (document.activeElement===last || !root.current?.contains(document.activeElement))){event.preventDefault();first.focus();}
      }
    };
    document.addEventListener('keydown',key);
    return()=>{document.removeEventListener('keydown',key);document.body.style.overflow=overflow;if(previous?.isConnected)previous.focus({preventScroll:true});};
  },[]);
  return root;
}
